import { gql } from "@apollo/client";

export const CreateInstalledBaseRegionSubscription = gql`
    mutation CreateInstalledBaseRegionSubscription ($regionId: ID!, $input: InstalledBaseRegionSubscriptionInput!) {
        createInstalledBaseRegionSubscription(regionId: $regionId, input: $input) {
            id
            inApp
            mail
            push
            iotAlert
            iotAlertSeverity
            maintenanceDue
            maintenanceSeverity
            maintenanceType
            insert
            update
            region {
                id
                name
            }
        }
    }
`;
